import { render, staticRenderFns } from "./expertDetail.vue?vue&type=template&id=45cf0ef0&scoped=true&"
import script from "./expertDetail.vue?vue&type=script&lang=js&"
export * from "./expertDetail.vue?vue&type=script&lang=js&"
import style0 from "./expertDetail.vue?vue&type=style&index=0&id=45cf0ef0&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45cf0ef0",
  null
  
)

export default component.exports